export class ProReportConstants {
  public static readonly backToMainWarning = 'This action will close the current report and discard any changes or notes you may have entered. Please click "Ok" to continue or "Cancel" to return to the current report.';
  public static readonly backToMainHeader = 'Leave Report?';

  public static readonly saveReportHeader = 'Save report';
  public static readonly saveReportWarning = 'Are you sure you want to save standard report for %obligorName%?';
  public static readonly downloadReportHeader = 'Please Confirm';
  public static readonly downloadReportWarning = 'Are you sure you want to download report for %obligorName%?';

  public static readonly munigardNewsURL = '/doc-mgn/';
  public static readonly docPdfURL = '/doc-pdf/';
}
